/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./dish-view-graphics";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
import * as i4 from "../../services";
var styles_DishViewGraphicsPage = [];
var RenderType_DishViewGraphicsPage = i0.ɵcrt({ encapsulation: 2, styles: styles_DishViewGraphicsPage, data: {} });
export { RenderType_DishViewGraphicsPage as RenderType_DishViewGraphicsPage };
export function View_DishViewGraphicsPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["class", "row"]], null, null, null, null, null))], null, null); }
export function View_DishViewGraphicsPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-dish-view-graphics", [], null, null, null, View_DishViewGraphicsPage_0, RenderType_DishViewGraphicsPage)), i0.ɵdid(1, 49152, null, 0, i1.DishViewGraphicsPage, [i2.NavController, i3.NavParams, i4.DishServices], null, null)], null, null); }
var DishViewGraphicsPageNgFactory = i0.ɵccf("page-dish-view-graphics", i1.DishViewGraphicsPage, View_DishViewGraphicsPage_Host_0, { dish: "dish" }, {}, []);
export { DishViewGraphicsPageNgFactory as DishViewGraphicsPageNgFactory };
//# sourceMappingURL=dish-view-graphics.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/dish/dish-view/dish-view-graphics/dish-view-graphics.ngfactory.js
// module id = null
// module chunks = 